export default "__VITE_ASSET__zUz5jsHf__"